var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vWindow"},[_c('div',{staticClass:"systemBar"},[_vm._t("systemBarContent",function(){return [_vm._v("WindowTitle")]})],2),_vm._v(" "),_c('div',{attrs:{"id":"vWindow-content"}},[_vm._t("content",function(){return [_vm._v("\n      Content will be inserted here. \n    ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }